var map = {
	"./AboutUs.vue": [
		"4733",
		"chunk-2d0c1919"
	],
	"./Article.vue": [
		"8192",
		"chunk-2c3bb37a",
		"chunk-1114af26"
	],
	"./Blog.vue": [
		"f2d6",
		"chunk-2c3bb37a",
		"chunk-06c1249a"
	],
	"./ContactUs.vue": [
		"7854",
		"chunk-2c3bb37a",
		"chunk-f84503e0"
	],
	"./CookiePolicy.vue": [
		"b683",
		"chunk-2d20ff05"
	],
	"./FindWellness.vue": [
		"5f89",
		"chunk-2c3bb37a",
		"chunk-2d0d2f14",
		"chunk-7356c7a2"
	],
	"./FrequentlyAskedQuestions.vue": [
		"a903",
		"chunk-2d2094f1"
	],
	"./HelpCenter.vue": [
		"bb02",
		"chunk-2c3bb37a",
		"chunk-2d21a338"
	],
	"./Home.vue": [
		"bc13",
		"chunk-2d21a719"
	],
	"./PatientManual.vue": [
		"9df3",
		"chunk-60a75ba3"
	],
	"./PracticeManual.vue": [
		"f5ac",
		"chunk-8d28ee86"
	],
	"./PractitionerManual.vue": [
		"40d51",
		"chunk-a6e24506"
	],
	"./Pricing.vue": [
		"551a",
		"chunk-2d0c85e6"
	],
	"./PrivacyPolicy.vue": [
		"de20",
		"chunk-2d229775"
	],
	"./Profile.vue": [
		"2ff9",
		"chunk-2c3bb37a",
		"chunk-2d0d2f14",
		"chunk-2d0be6fd"
	],
	"./TermsAndConditions.vue": [
		"f880",
		"chunk-2d22d800"
	],
	"./TermsAndConditions_Practitioner.vue": [
		"3d95",
		"chunk-2d0c4e63"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "a2f9";
module.exports = webpackAsyncContext;